import { render, staticRenderFns } from "./ConfirmActionModal.vue?vue&type=template&id=28b52eb8&"
import script from "./ConfirmActionModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmActionModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmActionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VDialog,VIcon,VTextarea})
